import WavePlayer from "./wavePlayer.vue";
export default WavePlayer;
